import { Link } from "react-router-dom";
import Stack from "@mui/material/Stack";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import { DOC_TYPE_LABEL } from "./documentMeta";
import { getEtaxBreadcrumbLabel } from "./etaxTitle";
import { ETAX_NOTE_SEND_PATH, ETAX_PATH, ETAX_SEND_PATH } from "./sendPaths";

const SEND_PAGE_TITLE = "ส่งเอกสาร E-Tax";
const BILL_TAB_LABEL = DOC_TYPE_LABEL.INV;
const NOTE_TAB_LABEL = `${DOC_TYPE_LABEL.CN} / ${DOC_TYPE_LABEL.DN}`;

const breadcrumbLinkStyle = { textDecoration: "none", color: "inherit" };

/** The tab's own path is its value, so the highlighted tab and the URL it points at cannot drift apart. */
type SendTabPath = typeof ETAX_SEND_PATH | typeof ETAX_NOTE_SEND_PATH;

interface SendPageHeaderProps {
  current: SendTabPath;
  /** `?date_from=…&date_to=…`, or "" — carried to the other tab and back to the dashboard. */
  dateSearch: string;
}

/**
 * Breadcrumb and tab bar shared by the two send lists: tax invoices and credit / debit notes.
 * Each tab is a real link to its own URL, so the date range survives the switch and the back
 * button walks between them.
 */
export default function SendPageHeader({ current, dateSearch }: Readonly<SendPageHeaderProps>) {
  return (
    <>
      <Stack direction="row" alignItems="center" mb={1}>
        <Link to={`${ETAX_PATH}${dateSearch}`} style={breadcrumbLinkStyle}>
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            {getEtaxBreadcrumbLabel()}
          </Typography>
        </Link>
        <Typography variant="body1" sx={{ mx: 1 }}>
          /
        </Typography>
        <Typography variant="body1" color="primary">
          {SEND_PAGE_TITLE}
        </Typography>
      </Stack>
      <Tabs value={current} sx={{ mb: 2 }}>
        <Tab
          component={Link}
          to={`${ETAX_SEND_PATH}${dateSearch}`}
          value={ETAX_SEND_PATH}
          label={BILL_TAB_LABEL}
        />
        <Tab
          component={Link}
          to={`${ETAX_NOTE_SEND_PATH}${dateSearch}`}
          value={ETAX_NOTE_SEND_PATH}
          label={NOTE_TAB_LABEL}
        />
      </Tabs>
    </>
  );
}
